// GENERATED by scripts/optimize-images.mjs - do not edit by hand.
// Country flags shipped as WebP because their SVG costs more than 5000
// bytes on the wire. Every other flag is served as SVG.
export const RASTER_FLAG_CODES: ReadonlySet<string> = new Set([
  'ad',
  'af',
  'as',
  'bm',
  'bo',
  'bt',
  'bz',
  'do',
  'ec',
  'es',
  'fj',
  'fk',
  'gs',
  'gt',
  'hr',
  'je',
  'ky',
  'me',
  'mp',
  'mt',
  'mx',
  'rs',
  'sv',
  'tm',
  'va',
]);
